import {
   Button,
   Dialog,
   DialogActions,
   DialogContent,
   DialogContentText,
   DialogTitle,
} from '@mui/material';

/**
 * Reusable confirmation dialog (same look as the other MUI dialogs in the app).
 * `children` renders under the message, e.g. a summary of what will change.
 */
function ConfirmDialog({
   open,
   title = 'Are you sure?',
   message,
   children,
   confirmText = 'Confirm',
   cancelText = 'Cancel',
   loading = false,
   onConfirm,
   onClose,
}) {
   return (
      <Dialog
         open={open}
         onClose={loading ? undefined : onClose}
         maxWidth="xs"
         fullWidth
         aria-labelledby="confirm-dialog-title"
      >
         <DialogTitle id="confirm-dialog-title" sx={{ fontWeight: 600 }}>
            {title}
         </DialogTitle>
         <DialogContent>
            {message && <DialogContentText component="div">{message}</DialogContentText>}
            {children}
         </DialogContent>
         <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={onClose} variant="outlined" disabled={loading}>
               {cancelText}
            </Button>
            <Button onClick={onConfirm} variant="contained" color="primary" disabled={loading}>
               {loading ? 'Please wait...' : confirmText}
            </Button>
         </DialogActions>
      </Dialog>
   );
}

export default ConfirmDialog;
